var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',[_c('navbar',{attrs:{"text":(_vm.currentFarmCode + " - " + (_vm.$t('TasksList_navbar_text'))),"new-icon-enable":false,"path-back":_vm.pathBack}}),_vm._v(" "),_c('accordionList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }